
import axios from 'axios'
import getColumns from './config/getColumns'
import { defineComponent } from 'vue'
import { Reward } from '@/store/types'
import { Currency } from '@/enums/Currency'
import Filters from '@/components/filters/Filters.vue'
import {
  FiltersType,
  getTableProperties,
  request,
  Row,
  Table,
  TableRequestProps,
} from '@/utils/request'
import { AffiliateAccessStatus } from '@/enums/AffiliateAccessStatus'
import {
  getActualRewards,
  getAmountsByRewards,
  getGeosForRewards,
  getTypesForRewards,
} from '@/utils/rewards'
import CampaignEditDialog from '@/components/dialogs/CampaignEditDialog.vue'
import { getIncludeOptions } from '@/utils/filters'
import SuperOffers from '@/pages/offers/components/SuperOffers.vue'
import {
  heroOutline24ArrowLongRight,
  heroOutline24ChevronLeft,
  heroOutline24ChevronRight,
} from 'quasar-extras-svg-icons/hero-icons-v2'

export default defineComponent({
  name: 'OffersList',
  components: { SuperOffers, Filters, CampaignEditDialog },
  async created() {
    await this.onRequest({ pagination: this.pagination })
  },
  setup() {
    return {
      heroOutline24ArrowLongRight,
      heroOutline24ChevronLeft,
      heroOutline24ChevronRight,
    }
  },
  computed: {
    columns(): any {
      return getColumns()
    },
  },
  data() {
    return {
      ...getTableProperties('id'),
      storageUrl: process.env.CDN_STORAGE_URL,
      filters: { affiliateAccess: false, ...getIncludeOptions() },
      currencies: Currency,
      showCampaignEditDialog: false,
      currentRowId: null,
    }
  },
  watch: {
    async filters() {
      this.pagination.page = 1
      await this.onRequest({ pagination: this.pagination })
    },
  },
  methods: {
    async getAccess(offerId: number) {
      await axios.get('/api/offers/access/' + offerId)
      await this.onRequest({ pagination: this.pagination })
    },
    createCampaign(offerId: number | null) {
      this.showCampaignEditDialog = true
      this.currentRowId = offerId as null
    },
    closeCampaignDialog() {
      this.showCampaignEditDialog = false
      this.currentRowId = null
    },
    hasAccess(status: AffiliateAccessStatus) {
      return status === AffiliateAccessStatus.Opened
    },
    onRowClick(evt: string, row: Row) {
      this.$router.push('/offers/' + row.id)
    },
    getRewardAmounts(rewards: Reward[]): string {
      return getAmountsByRewards(rewards)
    },
    getRewards(rewards: Reward[]) {
      return getActualRewards(rewards)
    },
    getGeos(row: any, firstOnly = false) {
      return getGeosForRewards(
        [...row.commonRewards, ...row.affiliateRewards],
        firstOnly,
      )
    },
    getRewardTypes(row: any) {
      return getTypesForRewards([...row.commonRewards, ...row.affiliateRewards])
    },
    async onRequest(props: TableRequestProps) {
      await request(props, this as Table, '/api/offers/')
    },
    onChangeFilters(field: string, value?: string) {
      if (value === undefined) {
        return
      }
      this.filters = {
        ...this.filters,
        [field]: value,
      }
    },
    changeAll(filters: FiltersType) {
      this.filters = { ...filters } as any
    },
    resetFilters() {
      this.pagination.page = 1
      this.filters = { affiliateAccess: false, ...getIncludeOptions() }
    },
    openInNewTab(row: Row) {
      const routeData = this.$router.resolve({
        name: 'offer',
        params: { id: row.id },
      })
      window.open(routeData.href, '_blank')
    },
  },
})
